import { isNonEmptyArray, isNonEmptyString } from '@/utils/checks'

const MINIMUM_INSURANCE_TOOLTIP_FIELDS = 1

export const shouldShowInsuranceTooltip = ({
  acceptedInsurance = [],
  insuranceDescription = '',
  verifyInsuranceLink = ''
}: {
  acceptedInsurance?: string[]
  insuranceDescription?: string
  verifyInsuranceLink?: string
} = {}): boolean => {
  return (
    [
      isNonEmptyArray(acceptedInsurance),
      isNonEmptyString(insuranceDescription),
      isNonEmptyString(verifyInsuranceLink)
    ].filter(Boolean).length >= MINIMUM_INSURANCE_TOOLTIP_FIELDS
  )
}

export default shouldShowInsuranceTooltip
